import { render, staticRenderFns } from "./Home_p.vue?vue&type=template&id=3039fad7&scoped=true"
import script from "./Home_p.vue?vue&type=script&lang=js"
export * from "./Home_p.vue?vue&type=script&lang=js"
import style0 from "./Home_p.vue?vue&type=style&index=0&id=3039fad7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3039fad7",
  null
  
)

export default component.exports